import { createContext, useContext } from 'react'
import type { AuthenticatedUser } from '../../types/domain'

export type SessionState = 'loading' | 'anonymous' | 'authenticated' | 'error'

export interface AuthContextValue {
  state: SessionState
  user: AuthenticatedUser | null
  error: string
  signIn: (email: string, password: string) => Promise<AuthenticatedUser>
  signOut: () => Promise<void>
  refreshProfile: () => Promise<AuthenticatedUser>
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth deve ser usado dentro de AuthProvider.')
  return context
}
